import { Component, OnChanges, Input, SimpleChanges, Output, EventEmitter} from '@angular/core';
import { ObjectNames, Status, Answer} from '../../constants/constants';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.scss']
})
export class GroupComponent implements  OnChanges {

  products = [];
  @Input() allTiers=[];
  @Output() showEditGroup = new EventEmitter<any>();
  @Output() deleteConfirmGroup = new EventEmitter<any>();
  @Output() viewGroupProducts = new EventEmitter<any>();
  discountGroupType = ObjectNames.priceBooksConstants.DiscountGroupType;
  statusConstants=Status;
  answertypeConstants = Answer;
  displayAddTier: boolean=false;
  selectedTiersToGroup;
  pricingData = [];
  pageNumber:number=1;
  first: number=0;
  pageSize:number=15;
  totalRecords: number=0;

  constructor(private confirmationService: ConfirmationService) { }


  ngOnChanges(changes: SimpleChanges): void {
    this.products= this.allTiers;
  }

  viewProducts(p){
    const discountTypeObj ={
      discountType: p,
      action: 'addbulkitemtotier'
    }
    const stringObj = JSON.stringify(discountTypeObj)
    this.viewGroupProducts.emit(stringObj);
  }

  addTierToGroup(p,child){
    const discountTypeObj ={
      discountType: p,
      group: child,
      action: 'addbulkitemtogroup'
    }
    const stringObj = JSON.stringify(discountTypeObj)
    this.viewGroupProducts.emit(stringObj);
  }

  showEditPricing(value){
   this.showEditGroup.emit(value);
  }

 deleteGroup(type,tier){
    this.confirmationService.confirm({
      message: 'Do you want to delete this Price Group?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        const item ={
          type: type,
          tier: tier
        }
        const stringObj = JSON.stringify(item);
        this.deleteConfirmGroup.emit(stringObj);
      },
      reject: () => {
      }
    });
  }

}
